import type { BrandSlug } from '../shared/brand-slug';
import type { OrgId, UserId } from '../shared/ids';

export type SubscriptionStatus = 'active' | 'paused' | 'paused_unpaid' | 'pending';

/** Statuses that block portal access and require reactivation. */
export function subscriptionBlocksAccess(status: SubscriptionStatus): boolean {
  return status === 'paused' || status === 'paused_unpaid';
}

export type OrgRole = 'user' | 'admin' | 'super-admin';

export type BrandBuckets = {
  readonly own: ReadonlySet<BrandSlug>;
  readonly competitor: ReadonlySet<BrandSlug>;
};

export type Organization = {
  readonly kind: 'organization';
  readonly id: OrgId;
  readonly displayName: string;
  readonly isSuperOrg: boolean;
  readonly subscription: SubscriptionStatus;
  readonly subscriptionEndsAt: Date | null;
  readonly buckets: BrandBuckets;
};

/** null means open-ended. */
export function periodEnded(org: Organization): boolean {
  if (org.subscriptionEndsAt === null) return false;
  return org.subscriptionEndsAt < new Date();
}

export type OrgMember = {
  readonly kind: 'org-member';
  readonly userId: UserId;
  readonly orgId: OrgId;
  readonly displayName: string | null;
  readonly role: OrgRole;
};

export function isAdmin(member: OrgMember): boolean {
  return member.role === 'admin' || member.role === 'super-admin';
}

export function isSuperAdmin(member: OrgMember): boolean {
  return member.role === 'super-admin';
}
